import React from 'react';

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { Box, TableCell, TableRow } from '@mui/material';

import { formatDateShort } from '~/services/TimeService';

import cruiseDealStatus from '~/utils/cruiseDealStatus';

import { CruiseDealPageBase } from '../types';

interface Props {
  dealPage: CruiseDealPageBase;
}

export default function DealPageListOrderItem({ dealPage }: Props) {
  const { attributes, isDragging, listeners, setNodeRef, transform, transition } = useSortable({
    id: dealPage.id,
  });

  const status = cruiseDealStatus({ startDate: dealPage.startDate, endDate: dealPage.endDate });

  return (
    <TableRow
      {...attributes}
      sx={{
        transform: CSS.Transform.toString(transform),
        transition,
      }}
    >
      <TableCell sx={{ display: 'flex', alignItems: 'center' }}>
        <Box ref={setNodeRef} {...listeners} sx={{ cursor: isDragging ? 'grabbing' : 'grab' }} mr={2}>
          <DragIndicatorIcon />
        </Box>
        {dealPage.name}
      </TableCell>
      <TableCell>{dealPage.cruiseLine.name}</TableCell>
      <TableCell>{formatDateShort(dealPage.startDate)}</TableCell>
      <TableCell>{formatDateShort(dealPage.endDate)}</TableCell>
      <TableCell>{status?.status}</TableCell>
    </TableRow>
  );
}
